export default __webpack_public_path__ + "static/media/T5-output1.18daf38d.png";